import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock, Unlock } from "lucide-react";
import { api, errMsg, fmtTime } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ResultsLockCard() {
  const { user } = useAuth();
  const [lock, setLock] = useState(null);
  const load = () => api.get("/results-lock").then((r) => setLock(r.data));
  useEffect(() => { load(); }, []);
  if (!lock) return null;
  const isSuper = user?.role === "super_admin";
  const toggle = async () => {
    const next = !lock.locked;
    const reason = window.prompt(next ? "Reason for locking final results" : "Reason for unlocking results", next ? "Auction completed" : "");
    if (reason === null) return;
    try {
      const r = await api.post("/admin/results-lock", { locked: next, reason });
      setLock(r.data);
      toast.success(next ? "Final results locked" : "Results unlocked");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className={`rounded-2xl border p-5 mb-6 flex flex-col sm:flex-row sm:items-center gap-4 ${lock.locked ? "border-emerald-500/40 bg-emerald-500/10" : "border-[#E5B842]/20 bg-white/[0.02]"}`} data-testid="results-lock-card">
      {lock.locked ? <Lock className="h-6 w-6 text-emerald-400 shrink-0" /> : <Unlock className="h-6 w-6 text-slate-400 shrink-0" />}
      <div className="flex-1">
        <p className="font-semibold" data-testid="results-lock-status">{lock.locked ? "Final results are LOCKED" : "Results are unlocked"}</p>
        <p className="text-sm text-slate-400">
          {lock.locked ? "No bids, sales, reversals, purse, team or player changes are allowed in either auction." : "Lock after the auction so no sale, purse or player can change by mistake."}
          {lock.updated_at && ` Last change ${fmtTime(lock.updated_at)} by ${lock.updated_by}.`}
        </p>
      </div>
      {isSuper && (
        <button onClick={toggle} data-testid="results-lock-toggle-btn"
          className={`px-5 py-2 rounded-full text-sm font-bold ${lock.locked ? "border border-white/20 text-white hover:bg-white/10" : "gold-bg"}`}>
          {lock.locked ? "Unlock results" : "Lock final results"}
        </button>
      )}
    </div>
  );
}
